<template>
  <div data-qa="Content-TimelineLog-Body">
    <el-row :gutter="20" :key="index" class="log-list" v-for="(item, index) of logList">
      <el-col :data-qa="`Content-TimelineLogType-Column-${index}`" :span="3">
        <el-tag :type="logType(item.type).color">{{ logType(item.type).label }}</el-tag>
      </el-col>
      <el-col :data-qa="`Content-TimelineLogDescribe-Column-${index}`" :span="10">
        <b>{{ item.action.label }}</b><b v-if="item.action.content || item.action.notification">: </b>
        <span>{{ getContent(item.action) }}</span>
        <span>{{ moreMessage(item.action) }}</span>
        <span v-if="item.action.conditions">{{ getConditionStatus (item.action.conditions) }}</span>
        <router-link @click="hideModel()" :data-qa="`Content-TimelineLogFromWho-Link-${index}`" :to="navigate(item)" class="from-who" replace>{{ fromWhom(item) }}</router-link>
      </el-col>
      <el-col :data-qa="`Content-TimelineLogViewInfo-Column-${index}`" :span="4">
        <el-tooltip placement="top" v-if="status[index]">
          <div class="status-tooltip" slot="content">
            <el-row>
              <el-col :key="key" :span="6" v-for="(value, key) in status[index].content">
                {{ key }}: {{ value }}
              </el-col>
            </el-row>
          </div>
          <a @mouseover="getInfo(index, item.identity, item.time, item.action.device_unique_id)" :data-qa="`Content-TimelineLogViewInfo-Link-${index}`" class="view-info">
            {{ $t('timelineLogLinkViewInfoText') }}
          </a>
        </el-tooltip>
        <a @mouseover="getInfo(index, item.identity, item.time, item.action.device_unique_id)" :data-qa="`Content-TimelineLogViewInfo-Link-${index}`" class="view-info" v-else>
          {{ $t('timelineLogLinkViewInfoText') }}
        </a>
      </el-col>
      <el-col :data-qa="`Content-TimelineLogTime-Column-${index}`" :span="7">
        {{ item.time | formatDate }}
      </el-col>
    </el-row>
    <div class="empty-message" data-qa="Content-TimelineLog-Empty" v-if="isEmpty">
      {{ $t('timelineLogEmptyMessage') }}
    </div>
  </div>
</template>

<script>
  import main from './TimelineLog.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './TimelineLog.scss'
</style>



// WEBPACK FOOTER //
// TimelineLog.vue?87b12e28